module.exports = __webpack_public_path__ + "static/media/faccia_01.3ba7092d.png";